import { cn } from "@bowfast/ui/lib/utils";
import { CompassIcon, Navigation2Icon, SailboatIcon } from "lucide-react";

interface OverlayPassageStatsProps {
  totalDistance: number;
  estimatedDuration: string;
  averageSpeed: number;
}

export function OverlayPassageStats({
  totalDistance,
  estimatedDuration,
  averageSpeed,
}: Readonly<OverlayPassageStatsProps>) {
  const stats = [
    { value: totalDistance.toLocaleString(), label: "nm total", color: "text-abyss-400", Icon: Navigation2Icon },
    { value: estimatedDuration, label: "est. duration", color: "text-shallow-400", Icon: CompassIcon },
    { value: String(averageSpeed), label: "avg kn", color: "text-white/80", Icon: SailboatIcon },
  ];

  return (
    <div className="grid grid-cols-3 gap-px overflow-hidden rounded-lg border border-white/10 bg-white/5">
      {stats.map((stat) => (
        <div key={stat.label} className="flex items-center gap-2 bg-white/5 px-3 py-2.5">
          <stat.Icon className={cn("size-3.5 shrink-0", stat.color)} />
          <div>
            <p className={cn("font-heading text-base font-bold leading-none tabular-nums", stat.color)}>{stat.value}</p>
            <p className="mt-0.5 text-[0.6rem] text-white/40">{stat.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
